<template>
  <main class="relative home-page">

    <!-- <div id="noise-bg"/> -->

    <section ref="heroHome" class="relative w-full hero-section bg-ellie-yellow z-[2] overflow-hidden" @mouseenter="toggleHover(true, 'scroll-down')" @mouseleave="toggleHover(false)">
      <HeroSectionNew @on-loaded = "handleLoaded()" @on-play-video="watchReel" />
    </section>

    <ClientOnly>
      <div ref="triggerNavbar" class="relative w-full h-full trigger-navbar">
        <div class="relative w-full h-full z-[5] bg-white">
          <div class="relative w-full h-full z-10">
    
            <div class="relative h-[200vh] w-full trigger-animate-company">
              <div class="sticky top-0 md:-top-10 z-10 bg-white bg-opacity-60 pb-20 lg:pb-0 lg:bg-opacity-0 masking-gradient-bottom">
                <CompanyDetails />
              </div>
            </div>
            
            <div class="relative w-full h-full container-1">
    
              <div class="hidden absolute top-0 left-0 w-full h-full lg:grid grid-cols-3 masking-gradient-y-2">
                <div class="w-full h-full"/>
                <div class="w-full h-full border-x border-gray-300 border-opacity-20"/>
                <div class="w-full h-full"/>
              </div>

              <div class="relative w-full h-[150vh] lg:h-[250vh] trigger-works-title-animation">
                <ClientOnly>
                  <WorkGenre v-if="isLargeScreen" />
                  <WorkGenreMobile v-else />

                  <WorksTitle v-if="isLargeScreen"/>
                </ClientOnly>
              </div>

              <div class="trigger-works"/>
              <section class="relative">
                <ClientOnly>
                  <WorksGrid v-if="isLargeScreen" />
                  <WorksGridMobile v-else />
                </ClientOnly>
              </section>
            </div>
          </div>

          <div class="relative w-full h-full gradient-humans overflow-x-clip trigger-service-container">
            <ClientOnly>
              <OurServicesBackground2 />
              <section ref="titleWork" class="relative w-full h-full services py-48 overflow-clip">
                <OurServiceSlider2 />
              </section>
            </ClientOnly>
          </div>
    
          <section class="bg-ellie-yellow py-10 md:py-[3.125vw]">
            <OurClients />
          </section>
    
          <section class="relative w-full h-full">
            <ClientOnly>
              <TestimonialSlider/>
            </ClientOnly>
            <div class="absolute left-0 bg-white rounded-tl-3xl -bottom-24 -translate-y-[50%] w-[5vw] md:w-[2vw] 2xl:w-[4vw] h-24 z-[2]"/>
            <div class="absolute left-0 bg-ellie-purple rounded-tl-[4rem] -bottom-24 -translate-y-0 w-[5vw] md:w-[2vw] 2xl:w-[4vw] h-24 z-10"/>
          </section>
          <div id="triggerFooter" class="dark w-full h-8 block -mt-8"/>
        </div>
        <div class="sticky bottom-0 !z-0 w-full h-full">
          <UIFooter />
        </div>

      </div>
    </ClientOnly>
    
  </main>

  <div v-if="playingReel" class="fixed w-full h-full top-0 left-0 z-[9999] items-center flex px-6">
    <div class="reel-scrim w-full h-full bg-ellie-purple absolute transition-transform left-0"/>
    <div class="reel-player-container relative w-full">
    <div class="flex h-full w-full items-center sm:p-6">
      <video
        loop
        playsinline
        class="opacity-0 reel-player-video w-full h-full object-cover rounded-lg max-h-[calc(100vh-3rem)] shadow-xl"
        src="/video/home-reel.mp4"
        @timeupdate="updateSeeker"/>
    </div>
    <div
      :class="[
          'player-control',
          controlsVisible ? 'opacity-100' : 'opacity-0 pointer-events-none translate-y-8',
        ]"
        class="absolute bottom-12 left-0 w-full flex items-center justify-center gap-3 px-3 transition-transform">
        <div class="flex items-center justify-center gap-1 bg-black rounded-md h-auto w-full max-w-sm">
          <button class="text-ellie-yellow w-8 h-8 flex items-center justify-center" @mouseenter="toggleHover(true)" @mouseleave="toggleHover(false)" @click="playPause()">
            <!-- Play or Pause Icons -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-4 absolute transition-transform" :class="paused ? 'rotate-180 opacity-0':'rotate-0'">
              <path fill-rule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z" clip-rule="evenodd" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-4 absolute transition-transform" :class="!paused ? 'rotate-180 opacity-0':'rotate-0'">
              <path fill-rule="evenodd" d="M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z" clip-rule="evenodd" />
            </svg>
          </button>
          <div
            class="player-timeline pr-3 flex-grow cursor-pointer" @mouseenter="toggleHover(true)"
            @mouseleave="toggleHover(false)"
            @click="seekVideo">
            <div class="player-timeline-container h-3 items-center flex">
              <div class="bg-ellie-yellow/50 h-1 w-full rounded-full">
                <div
                  :style="{ width: progress + '%' }"
                  class="player-timeline-seeker transition-all duration-100 bg-ellie-yellow h-1 rounded-full"/>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-center gap-1 bg-black rounded-md h-auto">
          <button class="text-ellie-yellow w-8 h-8 flex items-center justify-center transition-transform hover:rotate-180" @mouseenter="toggleHover(true)" @mouseleave="toggleHover(false)" @click="closeReel()">
            <!-- Close Icon -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-4">
              <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>

</template>
<script setup>
import { Interactions } from '../interactions';

const { $anime, $ScrollTrigger } = useNuxtApp();
const route = useRoute();
const emits = defineEmits(['onLoaded']);
definePageMeta({
  layout: 'home-layout',
});

useHead(() => ({
  link: [
    {
      rel: 'canonical',
      href: 'https://elliemotion.com' + route.path,
    },
  ],
}));

useSeoMeta({
  title: 'Creative Video Production House in Singapore | Ellie Motion',
  description: 'Discover a creative video production house in Singapore. We provide video \nproduction services, specializing in animation and motion graphics. Contact \nus now!',
  image: '/android-chrome-192x192.png',
  url: 'https://elliemotion.com',
  type: 'website',
  site_name: 'Ellie Motion',
  viewport: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no',
  locale: 'en-GB',
  og: {
    title: 'Creative Video Production House in Singapore | Ellie Motion',
    description: 'Discover a creative video production house in Singapore. We provide video production services, specializing in animation and motion graphics. Contact us now!',
    image: '/android-chrome-192x192.png',
    url: 'https://elliemotion.com',
    type: 'website',
    site_name: 'Ellie Motion',
  },
  twitter: {
    title: 'Creative Video Production House in Singapore | Ellie Motion',
    image: '/android-chrome-192x192.png',
    url: 'https://elliemotion.com',
    card: 'summary',
    description: 'Discover a creative video production house in Singapore. We provide video production services, specializing in animation and motion graphics. Contact us now!',
  },
});

const mainStore = useMainStore();
const navbarStore = useNavbarStore();
const { showNavbar } = storeToRefs(navbarStore);
const hoveringButton = computed(() => mainStore.track);

const isMediumScreen = useMediaQuery('(min-width: 768px)');
const isLargeScreen = useMediaQuery('(min-width: 1024px)');

const interactionsVar = new Interactions();

const triggerNavbar = ref(null);
const observerTriggerNavbar = useIntersectionObserver(
  triggerNavbar, 
  ([entry], observerElement) => {
      const navbarInContainer = entry?.isIntersecting || false
      if(navbarInContainer) {
        navbarStore.changeLogoColor('default');
      } else {
        navbarStore.changeLogoColor('blue');
      }
    },
);

const startLenis = () => {
  if (interactionsVar) {
    interactionsVar.createSmoothScroll();
    interactionsVar.startLenis();
    interactionsVar.lenis.on('scroll', (e) => {
      navbarStore.setScrollProgress(e.progress);
      if (interactionsVar.lenis.direction < 0) {
        navbarStore.showNavbarValue();
      } else {
        navbarStore.hideNavbarValue();
      }
    });
  }
};

const destroyLenis = () => {
  if (interactionsVar) interactionsVar.destroyLenis();
};

const showControls = () => {
  controlsVisible.value = true;
  resetIdleTimer();
};

const hideControls = () => {
  controlsVisible.value = false;
};

const resetIdleTimer = () => {
  clearTimeout(idleTimer);
  idleTimer = setTimeout(hideControls, idleTimeout);
};

const handleUserActivity = () => {
  if (!controlsVisible.value) showControls();
  resetIdleTimer();
};

onMounted(() => {
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 0);

  nextTick(() => {
    startLenis();
  });
});

onBeforeUnmount(() => {
  destroyLenis();
  mainStore.toggleTrackingMouse(false, 'default');
});

const toggleHover = (isHover, type = 'default') => {
  const payload = { isHover, type };
  mainStore.toggleTrackingMouse(payload);
};

const handleLoaded = () => {
  emits('onLoaded');
};

const progress = ref(0);
const controlsVisible = ref(true);
let idleTimer = null;
const idleTimeout = 3000;
const watchReelTimeout = ref(null);
const playingReel = ref(false);
const watchReel = () => {
  playingReel.value = true;
  if (watchReelTimeout.value) clearTimeout(watchReelTimeout);
  nextTick(() => {
    const videoContainer = document.querySelector('.reel-player-container');
    const realScrimEl = document.querySelector('.reel-scrim');
    const videoEl = document.querySelector('.reel-player-video');
    const playerControl = document.querySelector('.player-control');

    if (!realScrimEl) return;

    hideControls();
    realScrimEl.style.transition = 'transform 0.8s cubic-bezier(0.9, 0.25, 0.1, 1)';
    videoEl.style.transition = 'opacity 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)';
    playerControl.style.transition = 'all 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)';
    realScrimEl.style.transform = 'translateY(100%)';
    watchReelTimeout.value = setTimeout(() => {
      realScrimEl.style.transform = 'translateY(0%)';
    }, 300);
    watchReelTimeout.value = setTimeout(() => {
      videoEl.style.opacity = '1';

      showControls();
      videoContainer.addEventListener('mousemove', handleUserActivity);
      videoContainer.addEventListener('click', handleUserActivity);
      // pause trailer
      // trailer.pause();

      // play reel
      videoEl.play();
    }, 1200);
  });
};

const closeReel = () => {
  if (watchReelTimeout.value) clearTimeout(watchReelTimeout);
  nextTick(() => {
    const videoContainer = document.querySelector('.reel-player-container');
    const realScrimEl = document.querySelector('.reel-scrim');
    const videoEl = document.querySelector('.reel-player-video');
    const playerControl = document.querySelector('.player-control');
    if (!realScrimEl) return;

    hideControls();
    videoContainer.removeEventListener('mousemove', handleUserActivity);
    videoContainer.removeEventListener('click', handleUserActivity);
    clearTimeout(idleTimer);

    // play trailer
    // const trailer = document.querySelector('#vid-reel');
    // trailer.play();

    // pause reel
    videoEl.pause();

    videoEl.style.transition = 'transform 1s cubic-bezier(0.9, 0.1, 0.5, 1)';
    realScrimEl.style.opacity = 0;
    videoEl.style.transform = 'translate3d(0, 100vh, 0) rotate(-10deg)';
    realScrimEl.style.transition = 'opacity 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)';
    playerControl.style.transition = 'transform opacity 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)';
    watchReelTimeout.value = setTimeout(() => {
      playingReel.value = false;
      progress.value = 0;
    }, 1000);
  });
};

const updateSeeker = () => {
  nextTick(() => {
    const videoEl = document.querySelector('.reel-player-video');
    const currentTime = videoEl.currentTime;
    const duration = videoEl.duration;
    progress.value = (currentTime / duration) * 100;
  });
};

const seekVideo = (event) => {
  nextTick(() => {
    const videoEl = document.querySelector('.reel-player-video');
    const seekerEl = document.querySelector('.player-timeline-container');
    const rect = seekerEl.getBoundingClientRect();
    const offsetX = event.clientX - rect.left; // Click position relative to the timeline
    const width = rect.width;
    const seekTime = (offsetX / width) * videoEl.duration;
    videoEl.currentTime = seekTime;
  });
};

const paused = ref(false);
const playPause = () => {
  const videoEl = document.querySelector('.reel-player-video');
  paused.value = !paused.value;
  if (paused.value) {
    videoEl.pause();
  } else {
    videoEl.play();
  }
};

</script>

<style lang="scss">
  .reel-player-video {
      transform-origin: bottom right;
      display: block;
      width: auto;
      max-width: 100%;
      height: auto;
      margin-left: auto;
      margin-right: auto;
  }
  .reel-player-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .player-timeline-seeker {
    transition: width .1s ease-out;
  }

  #el {
    width: 100vw;
    height: 100vh;
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    background-color: white;
    -webkit-mask-image: url(/graphics/polygon.svg);
    -webkit-mask-size: var(--mask-size);
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-image: url(/graphics/polygon.svg);
    mask-size: var(--mask-size);
    mask-repeat: no-repeat;
    mask-position: center;
  }
</style>
